import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import SubmitPage from "./submit"
import Capture from "./capture"

const ScanPage = () => {

    const navigate = useNavigate()
    const { images } = useSelector((state) => state.fullScan);
    const [activeImageSide, setImageSide] = useState(images.length < 5 ? images.length : 0)
    const allPhotosCaptured = images.length >= 5;

    useEffect(() => {

        if (!localStorage.getItem("usertpi") || localStorage.getItem("isScanCompleted")) {
            navigate(`/signalai_wohd`)
        }


    }, [activeImageSide])


    return (
        <div className="h-full w-full">
            {
                allPhotosCaptured ? <SubmitPage /> : <Capture activeImageSide={activeImageSide} setImageSide={setImageSide} />
            }
        </div>
    )
}

export default ScanPage